export const REPORT_ISSUE_TITLE = 'Report an issue';

export const REPORT_ISSUE_DESCRIPTION_LABEL = 'What went wrong?';

export const REPORT_ISSUE_DESCRIPTION_HINT = 'Tell us what you were trying to do and what happened instead.';

export const REPORT_ISSUE_DESCRIPTION_PLACEHOLDER = 'For example: the Net worth page shows a blank screen.';

export const REPORT_ISSUE_ATTACHMENT_LABEL = 'Attach a screenshot (optional)';

export const REPORT_ISSUE_SUBMIT_LABEL = 'Send report';

export const REPORT_ISSUE_DONE_LABEL = 'Done';

export const REPORT_ISSUE_SUBMIT_ERROR = 'We could not send your report. Please try again.';

export const REPORT_ISSUE_MAX_DESCRIPTION_LENGTH = 5000;

export const REPORT_ISSUE_MAX_IMAGE_BYTES = 10 * 1024 * 1024;

export const REPORT_ISSUE_ALLOWED_IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp'] as const;

export const REPORT_ISSUE_ENDPOINT = '/api/support/client/create';

export const REPORT_ISSUE_TIMEOUT_MS = 30_000;

export function reportIssueConfirmation(reference: string | null): string {
  const received = reference === null ? 'We received your report.' : `We received your report (${reference}).`;
  return `${received} Our team will look into it. We do not reply to these reports, so contact your advisor if you need help.`;
}
